export const et = {
  lang: "et",
  rules: "Reeglid",
  cupra: "Cupra Formentor",
  rulesheading: "Vikinglotto lisaloos 2025 mängureeglid",
  language: "Language",
  heroTitle1: "VIKINGLOTTO",
  heroTitle2: "LISALOOS",
  buyticket: "Osta pilet",
  heroSubtitle:
    "Loosime välja 2 pistikhübriidi Cupra Formentor, 5 x 10 000 € ja 10 x 5000 €! Osalevad vähemalt kahe väljaga piletid.",
  watchVideo: "...",
  footerDisclaimer:
    "TÄHELEPANU! Tegemist on hasartmängu reklaamiga. Hasartmäng pole sobiv viis rahaliste probleemide lahendamiseks. Tutvuge reeglitega ja käituge vastutustundlikult!",
  rulesContent: "...",
  home: "Home",
  skipToContent: "Skip to main content",
  navMenu: "Main Navigation",
  videoDescription: "...",
};
